import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import axios from '../../services/MyAxios';

import DrawsList from '../draw/DrawsList';

import LotteryAbout from './LotteryAbout';
import LotteryDetails from './LotteryDetails';
import LotteryGameTypes from './LotteryGameTypes';
import LotteryMetrics from './LotteryMetrics';
import LotteryRuleTiers from './LotteryRuleTiers';
import LotteryRules from './LotteryRules';

export default function LotteryShow() {
    const { slug } = useParams();
    const [lottery, setLottery] = useState({});
    const url = `/crea/api/lottery/${slug}`;
    const metricsUrl = `/crea/api/metrics/${slug}`;
    useEffect(() => {
        axios.get(url).then((response) => {
            setLottery(response.data);
        });
    }, []);

    return (
        <div>
            <LotteryMetrics url={metricsUrl} />
            <LotteryAbout url={`${url}/about`} />
            <LotteryDetails lottery={lottery} />
            <LotteryRules
                url={`${url}/current_rules`}
                lotteryDisplaySlug={slug}
                isPriceEditable={lottery.system_commission_type === 'default'}
            />
            <LotteryRuleTiers slug={slug} url={`${url}/rule_tiers`} />
            <LotteryGameTypes url={`${url}/current_game_types`} />
            <DrawsList url={`${url}/draws`} />
        </div>
    );
}
